import React, { useState } from 'react';
import { Box, Pressable } from 'native-base';
import { Platform } from 'react-native';
import { Text, ChevronIcon } from '../atoms';
export function SectionList({ header, body, label = '', onPress, 
// @ts-expect-error TODO: use token
onPressBgColor = '#eaeaea', bodyFontSize = 'md', bodyFontWeight = 400, bodyFontColor = 'text.80', heading, headingFontColor = 'text.100', headingFontSize = 'lg', headingFontWeight = 500, labelFontSize = 'md', labelFontColor = 'interactive.text.active', iconLeftMargin = 1, headerFontWeight = 'semiBold', headerFontSize = 'md', headerFontColor = 'text.100', }) {
    const isPressable = typeof onPress === 'function';
    const [showBgColorChange, setShowBgColorChange] = useState(false);
    return (React.createElement(React.Fragment, null,
        header && (React.createElement(Box, { borderBottomWidth: 1, borderBottomColor: "neutral.30", mt: 4, pb: 2 },
            React.createElement(Text, { fontWeight: headerFontWeight, fontSize: headerFontSize, color: headerFontColor }, header))),
        React.createElement(Pressable, { android_ripple: {
                color: onPressBgColor,
            }, onPressIn: () => {
                if (isIos) {
                    setShowBgColorChange(true);
                }
            }, onPressOut: () => {
                if (isIos) {
                    setShowBgColorChange(false);
                }
            }, disabled: !isPressable, alignItems: "center", py: 4, borderBottomWidth: 1, borderBottomColor: "neutral.30", onPress: onPress, flexDir: "row", backgroundColor: showBgColorChange ? onPressBgColor : undefined },
            React.createElement(Box, { flex: 1 },
                heading && (React.createElement(Text, { fontWeight: headingFontWeight, fontSize: headingFontSize, color: headingFontColor }, heading)),
                body && (React.createElement(Text, { fontSize: bodyFontSize, flexGrow: 1, color: bodyFontColor, fontWeight: bodyFontWeight }, body))),
            React.createElement(Text, { fontSize: labelFontSize, color: isPressable ? labelFontColor : 'text.40' }, label),
            isPressable && (React.createElement(Box, { ml: iconLeftMargin },
                React.createElement(ChevronIcon, { size: 4, fill: "neutral.70" }))))));
}
const isIos = Platform.OS === 'ios';
